module.exports = __webpack_public_path__ + "img/guide28801.929ddfe7.png";